import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelMarketInsightUpsellController from 'lumen/controllers/hotel/market-insight-upsell';
import type { Transition } from 'lumen/services/transition';

export default class HotelMarketInsightUpsellRoute extends Route {
  @service declare access: Services['access'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.access.hasFeature('app.market_insight_upsell')) {
      this.transition.redirectToEnabledTab(transition);
    }
  }

  resetController(
    controller: HotelMarketInsightUpsellController,
    isExiting: boolean,
  ): void {
    if (isExiting) {
      controller.stopPolling();
    }
  }

  setupController(controller: HotelMarketInsightUpsellController): void {
    if (
      controller.activeModalView === controller.MODAL_VIEWS.AWAITING_TRIAL_SETUP
    ) {
      controller.startPolling();
    }
  }
}
